// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Aubi","newExpiryDate":"styles_newExpiryDate__3zmHW","footer":"styles_footer__2ujtx"};